/**
 * แปลงคอลัมน์ "ข้อมูลอ้างอิง" ของ Log การลงลายมือชื่อให้เป็นบรรทัด key: value
 *
 * ค่าที่เก็บเป็น JSON ที่ระบบ e-Coding เดิมเขียนไว้ เช่น
 * {"referent":"...","user":"...","taxid":"...","mokoso_id":"..."}
 * แถวเก่าบางแถวมีค่า null (เช่น referent) ระบบเดิมแสดงเป็น "-" จึงต้องทำเหมือนกัน
 * ถ้าข้อมูลไม่ใช่ JSON (ข้อมูลเก่าที่เพี้ยน) ให้แสดงค่าดิบไปเลย ดีกว่าไม่แสดงอะไร
 */
export function parseSignLogReference(ref: string | undefined | null): [string, string][] {
  if (!ref) {
    return [];
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(ref);
  } catch {
    return [['raw', ref]];
  }
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return [['raw', ref]];
  }
  const entries = Object.entries(parsed as Record<string, unknown>);
  if (entries.length === 0) {
    return [['raw', ref]];
  }
  return entries.map(([key, value]) => [key, displayValue(value)] as [string, string]);
}

function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return String(value);
}
